import React, { forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react';
import { FieldProps } from 'formik';

import Select, { ISelectProps } from './Select';
import FieldWrapper from '../FieldWrapper/FieldWrapper';

interface SelectFieldProps extends Partial<ISelectProps>, RefAttributes<HTMLSelectElement> {
  label?: string;
  field?: FieldProps['field'];
  meta?: FieldProps['meta'];
  form?: FieldProps['form'];
}

const SelectField: ForwardRefExoticComponent<SelectFieldProps> = forwardRef(
  ({ field, meta, form, label, ...rest }, ref) => {
    const hasError = meta?.touched && !!meta?.error;
    const isSubmitting = form?.isSubmitting;

    return (
      <FieldWrapper error={hasError && meta?.error} label={label}>
        <Select 
          ref={ref} 
          {...rest} 
          {...field} 
          disabled={isSubmitting || rest.disabled} 
        />
      </FieldWrapper>
    );
  }
);

export default SelectField;
